import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import siteConfig from '../../config/site-config';

// Social scrapers need an absolute image URL; content stores a site-relative
// one so it does not hard-code the domain.
const ABSOLUTE_IMAGE_TAGS = ['og:image', 'twitter:image'];

const absolutize = attributes => {
  if (!attributes) return attributes;
  const key = attributes.property || attributes.name;
  const value = attributes.content;
  if (
    ABSOLUTE_IMAGE_TAGS.includes(key) &&
    typeof value === 'string' &&
    value.startsWith('/')
  ) {
    return { ...attributes, content: `${siteConfig.siteUrl}${value}` };
  }
  return attributes;
};

/**
 * Renders the meta tags stored with each page's content.
 *
 * This used to be DatoCMS's <HelmetDatoCms />. The tag list it consumed is now
 * hard-coded in src/content, in the same shape it always had:
 *
 *   { tags: [ { tagName: 'title', content: '…' },
 *             { tagName: 'meta', attributes: { property: 'og:title', … } } ] }
 */
const SEO = ({ meta }) => {
  const tags = (meta && meta.tags) || [];

  return (
    <Helmet>
      {tags.map(({ tagName, content, attributes }, i) => {
        if (tagName === 'title') return <title key={i}>{content}</title>;

        const Tag = tagName;
        const attrs = absolutize(attributes);
        // `content` on a non-title tag is the tag's body (e.g. JSON-LD script).
        return content ? (
          <Tag key={i} {...attrs}>
            {content}
          </Tag>
        ) : (
          <Tag key={i} {...attrs} />
        );
      })}
    </Helmet>
  );
};

SEO.propTypes = {
  meta: PropTypes.object,
};

export default SEO;
